import { Stack, Sticky } from "components";
import ClaimVoucherForm from "features/vouchers/ClaimVoucherForm";
import VouchersList from "features/vouchers/VouchersList";
import { AppointmentType, Voucher } from "types";

type VoucherPickerProps = {
  type: AppointmentType;
  doctor?: string;
  active?: Voucher;
  disabled: boolean;
  onChange(voucher: Voucher): void;
};

const VoucherPicker: React.FC<VoucherPickerProps> = ({
  type,
  doctor,
  active,
  disabled,
  onChange,
}) => {
  const disabledStyle: React.CSSProperties = {
    background: "rgba(255, 255, 255, 0.5)",
    position: "absolute",
    inset: 0,
    zIndex: 100,
  };

  const stickyStyle = {
    top: "-32px",
    padding: "16px 8px",
    margin: "-16px -8px",
    zIndex: 10,
  };

  return (
    <Stack gap={2} direction="column" style={{ position: "relative" }}>
      {disabled && <span style={disabledStyle} />}

      <Sticky style={stickyStyle}>
        <ClaimVoucherForm />
      </Sticky>

      {doctor && (
        <VouchersList
          type={type}
          doctor={doctor}
          active={active}
          onChange={onChange}
        />
      )}
    </Stack>
  );
};

export default VoucherPicker;
